'use strict';

var Css = require("bs-css-emotion/src/Css.bs.js");
var List = require("bs-platform/lib/js/list.js");
var $$Array = require("bs-platform/lib/js/array.js");
var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var DownloadPage = require("./Js/downloadPage").default;
var Utils$FormBuilder = require("./utils/Utils.bs.js");
var Button$FormBuilder = require("./components/elements/Button.bs.js");
var Mixins$FormBuilder = require("./styles/Mixins.bs.js");
var FormContext$FormBuilder = require("./Context/FormContext.bs.js");
var FormPreview__Style$FormBuilder = require("./styles/FormPreview__Style.bs.js");
var PreviewIllustration$FormBuilder = require("./components/PreviewIllustration.bs.js");

function downloadPage(prim) {
  DownloadPage();
  
}

function str(prim) {
  return prim;
}

function FormPreview$InputNumber(Props) {
  var number = Props.number;
  return React.createElement("span", {
              style: {
                color: "#ccc",
                fontSize: "2.6rem"
              }
            }, String(number) + ".");
}

var InputNumber = {
  make: FormPreview$InputNumber
};

function FormPreview$Question(Props) {
  var text = Props.text;
  return React.createElement("div", {
              className: FormPreview__Style$FormBuilder.question(text === "")
            }, text === "" ? "Question goes here" : text);
}

var Question = {
  make: FormPreview$Question
};

function FormPreview(Props) {
  var match = React.useContext(FormContext$FormBuilder.context);
  var dispatch = match[1];
  var state = match[0];
  console.log("ree");
  return React.createElement("div", {
              className: FormPreview__Style$FormBuilder.outputContainer
            }, React.createElement("form", {
                  className: FormPreview__Style$FormBuilder.outputFormContainer
                }, List.length(state.form) === 0 ? React.createElement(PreviewIllustration$FormBuilder.make, {}) : null, React.createElement("div", undefined, $$Array.of_list(List.mapi((function (i, item) {
                                if (item.TAG === /* Text */0) {
                                  var input = item._0;
                                  return React.createElement("div", {
                                              key: input.id,
                                              className: FormPreview__Style$FormBuilder.inputContainer
                                            }, React.createElement(FormPreview$InputNumber, {
                                                  number: i + 1 | 0
                                                }), React.createElement(FormPreview$Question, {
                                                  text: input.question
                                                }), React.createElement("input", {
                                                  className: FormPreview__Style$FormBuilder.textInput,
                                                  placeholder: "Type your answer",
                                                  value: input.answer,
                                                  onChange: (function ($$event) {
                                                      var value = $$event.target.value;
                                                      Curry._1(dispatch, {
                                                            TAG: /* Answer */5,
                                                            _0: input.id,
                                                            _1: value
                                                          });
                                                      
                                                    })
                                                }));
                                }
                                var rangeValue = item._1;
                                var input$1 = item._0;
                                var start = item._2 === /* Zero */0 ? 0 : 1;
                                var range = Utils$FormBuilder.listOfRange(start, start === 0 ? rangeValue - 1 | 0 : rangeValue);
                                return React.createElement("div", {
                                            key: input$1.id,
                                            className: FormPreview__Style$FormBuilder.inputContainer
                                          }, React.createElement(FormPreview$InputNumber, {
                                                number: i + 1 | 0
                                              }), React.createElement(FormPreview$Question, {
                                                text: input$1.question
                                              }), React.createElement("div", {
                                                className: FormPreview__Style$FormBuilder.scaleContainer
                                              }, $$Array.of_list(List.map((function (it) {
                                                          return React.createElement("a", {
                                                                      className: Curry._1(Css.merge, {
                                                                            hd: input$1.answer === String(it) ? "active " : "",
                                                                            tl: {
                                                                              hd: FormPreview__Style$FormBuilder.scaleItem,
                                                                              tl: /* [] */0
                                                                            }
                                                                          }),
                                                                      href: "#",
                                                                      onClick: (function (e) {
                                                                          var value = e.target.innerText;
                                                                          return Curry._1(dispatch, {
                                                                                      TAG: /* Answer */5,
                                                                                      _0: input$1.id,
                                                                                      _1: value
                                                                                    });
                                                                        })
                                                                    }, String(it));
                                                        }), range))));
                              }), state.form)), List.length(state.form) !== 0 ? React.createElement("div", {
                            className: Curry._1(Css.merge, {
                                  hd: Mixins$FormBuilder.flex_center_center,
                                  tl: {
                                    hd: Curry._1(Css.style, {
                                          hd: Css.marginTop({
                                                NAME: "em",
                                                VAL: 4
                                              }),
                                          tl: /* [] */0
                                        }),
                                    tl: /* [] */0
                                  }
                                })
                          }, React.createElement(Button$FormBuilder.make, {
                                onClick: (function (e) {
                                    e.preventDefault();
                                    
                                  }),
                                text: "Submit"
                              })) : null)));
}

var make = FormPreview;

exports.downloadPage = downloadPage;
exports.str = str;
exports.InputNumber = InputNumber;
exports.Question = Question;
exports.make = make;
/* Css Not a pure module */
